import { Badge, Skeleton } from '@mantine/core'

export type WhatsApiMessageStatus = 'queued' | 'sent' | 'delivered' | 'read' | 'failed' | 'deleted'

export type HealthStatus = 'ok' | 'degraded' | 'down'

const HEALTH_STATUS_CONFIG: Record<HealthStatus, { color: string; label: string }> = {
  ok:       { color: 'green',  label: 'OK' },
  degraded: { color: 'yellow', label: 'Degradado' },
  down:     { color: 'red',    label: 'Indisponível' },
}

interface HealthStatusBadgeProps {
  status: HealthStatus | null
  loading?: boolean
  size?: 'xs' | 'sm' | 'md'
  tenantId?: number
}

export function HealthStatusBadge({ status, loading = false, size = 'sm' }: HealthStatusBadgeProps) {
  if (loading) {
    return <Skeleton height={20} width={90} radius="sm" data-testid="health-badge-skeleton" />
  }

  if (!status) {
    return (
      <Badge color="gray" variant="light" size={size} aria-label="Status: Desconhecido">
        Desconhecido
      </Badge>
    )
  }

  const config = HEALTH_STATUS_CONFIG[status]
  return (
    <Badge
      color={config.color}
      variant="light"
      size={size}
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </Badge>
  )
}

const STATUS_CONFIG: Record<WhatsApiMessageStatus, { color: string; label: string }> = {
  queued:    { color: 'yellow', label: 'Na fila' },
  sent:      { color: 'green',  label: 'Enviado' },
  delivered: { color: 'teal',   label: 'Entregue' },
  read:      { color: 'lime',   label: 'Lido' },
  failed:    { color: 'red',    label: 'Falhou' },
  deleted:   { color: 'gray',   label: 'Deletado' },
}

interface WhatsApiStatusBadgeProps {
  status: WhatsApiMessageStatus | string
  size?: 'xs' | 'sm' | 'md'
}

export function WhatsApiStatusBadge({ status, size = 'sm' }: WhatsApiStatusBadgeProps) {
  const config = STATUS_CONFIG[status as WhatsApiMessageStatus] ?? { color: 'gray', label: status }

  return (
    <Badge
      color={config.color}
      variant="light"
      size={size}
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </Badge>
  )
}
